const config = {
  apiHost: 'https://asia-southeast1-kslplus-service.cloudfunctions.net/api/v1',
  apiImportLotteries: 'https://lottery-publisher-api.lotteryplus.dev',
  apiImportMysteryBox: 'https://import-mystery-box-api.lotteryplus.dev',
  reportHost: 'https://asia-southeast1-kslplus-service.cloudfunctions.net/report',
  urlHost: 'https://asia-southeast1-kslplus-service.cloudfunctions.net',
  baseUrlLog: 'https://asia-southeast1-kslplus-service.cloudfunctions.net/monitoring',
  baseAPIExists: 'https://free-shirt-api.lotteryplus.dev',
  newPaymentAPI: 'https://payment-api.lotteryplus.dev',
  urlImageSlip: 'https://payment-status-vrh3svgpua-df.a.run.app',
  affiliateApiURL: 'https://affiliate-api.lotteryplus.dev',
  orderApiURL: 'https://order-api.lotteryplus.dev',
  apiGateway: 'https://user-api-gateway.lotteryplus.dev',
  apiAdminGateway: 'https://admin-api-gateway.lotteryplus.dev',
  apiAdminWsGateway: 'websocket-api-gateway.lotteryplus.dev',
  dataMatrixDetectionApi: 'https://datamatrix-detection-api.lotteryplus.dev',
  receiverIds: {
    ceo: 'JHKdU7uDqM2eX9tF99nV',
    u1: '2XhP1glAIEyBDmUqQlWB',
  },
  firebase: {
    apiKey: 'AIzaSyC6djajuET43zoLmveOaAprXat-R6nXA_8',
    authDomain: 'kslplus-service.firebaseapp.com',
    projectId: 'kslplus-service',
    storageBucket: 'kslplus-service.appspot.com',
    messagingSenderId: '1041205074054',
    appId: '1:1041205074054:web:a99ec75555aefb1592d907',
    measurementId: 'G-VZLXE9VWQB',
  },
  fcmKey:
    'AAAAVEY53Hw:APA91bHCji_Xij8egh45Xgz-IYok7qq3IAG-Kc8fiCf4lMdTajpIlJB2gBVzr6ZG7lRYDp9tWeFYuq_iR7JeU7ZhNx6uETR59w5g4pZh5EX3XkM32olOaouBWlcZ6CKkfaRHnM8UxeoQ',
  mongoChart: {
    confirmOrder: '64d5fbf8-4815-48ea-8c8c-a5bbb808682d',
    successOrder: '64d5fbf8-4815-4c02-87cd-a5bbb808682f',
    orderDailySeries: '64d5fbf8-4815-4f93-8e01-a5bbb8086833',
    orderHourSeries: '64d5fbf8-4815-4b74-8b89-a5bbb8086835',
    uniqueUser: '64dc9b1b-29c2-478a-8296-a39ebff63653',
    lotteryLast24Hours: '64d607d4-f3cb-467a-8239-ea67fef04a03',
    totalLottery: '64ddbe5d-f5ae-41e0-82c7-f7a931173f44',
    totalBox: '6513c3da-953f-4c96-84e3-2dbf35a163b2',
    remainLottery: '64ddbe3d-51cb-462b-87ae-40c9380dca39',
    remainBox: '64eae2f7-a75b-4a02-8549-91def4ce4a72',
    remainLotteryInCart: '64ec297e-6154-44ac-8505-c2aa4ef4bd10',
    publishLottery: '65093e26-8a91-4bc4-8aa6-c27d72381058',

    userDailySeries: '64df410a-c4a3-4738-874c-b60739a82e33',
    totalUser: '64df410a-c4a3-4545-8338-b60739a82e35',
    totalUserLast24Hours: '64df410a-c4a3-48a1-8604-b60739a82e37',
    orderRoundDateTable: '655712be-3a5a-4fee-829a-9aef44422170',
    newUserThisRound: '65374127-4a45-4255-8f0b-88f9fdb0a59e',
  },
  mongoChartUrl: 'https://charts.mongodb.com/charts-production-tggpe',
  newBODashboard: 'https://backoffice.lotteryplus.co.th/dashboard',
}
export default config
